module.exports = __webpack_public_path__ + "img/livro.43da3efc.png";